import React, { useState } from "react";
import { NewCreatableSelect, NewSelect } from "../..";
import { SelectFieldOption_Values, NewFieldStyles, NewFieldTypes } from "../../../Definitions";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { SelectFieldTableOption } from "../_Tables/useColumnConstructor";
import { CellContext } from "@tanstack/react-table";
import { focus_view } from "../../../Assets/Glyphs/focusView";

interface ListOptions<T> {
  options: SelectFieldTableOption<T>
}

export const ListTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, options, cell, focus_view}: CellContext<T, SelectFieldOption_Values | undefined> & EditAbleCell<T> & ListOptions<T>) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const divStyle = divStyleOverride ? divStyleOverride(styleOverrideOnValue ? value?.label : row.original.id) : undefined;

  const onChange = (newValue: SelectFieldOption_Values) => {
    setValue(newValue)
    if (newValue?.id !== initialValue?.id) {
      table.options.meta?.updateData(row.original.id, column.id, newValue, row);
    }
  }

  const isStatic = typeof staticColumn === "function" ? staticColumn(row) : staticColumn;
  return <ListStringCell options={typeof options === "function" ? options(row) : options} staticColumn={isStatic} key={cell.id} keyPass={cell.id+"Input"} onChange={onChange} canEdit={canEdit} cellData={{value, style: divStyle}} focus_view={focus_view} />
}

const ListStringCell = <T extends IdentifiableRow,> ({onChange, canEdit, cellData, keyPass, staticColumn, options, focus_view}: StyledTableCellProps & EditAbleCell<T> & {options: SelectFieldOption_Values[]}) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value.label ?? "") ?? ''}
        </div>
      );
    } else {
      return <NewSelect
        options={options}
        isSearchable={focus_view ? false : true}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary,
          fieldType: NewFieldTypes.tertiaryField,
          fieldWidth: "100%",
          menuWidth: focus_view ? undefined : "280px",
          focus_view: focus_view
        }}
        onChange={onChange}
        key={keyPass}
        valueOverrides={{
          defaultValue: cellData.value
        }}
      />;
    }
  }

  return (
    <div style={cellData.style} key={keyPass}>
      {String(cellData.value.label ?? "")}
    </div>
  )
}